import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, makeStyles, ButtonBase, RadioGroup, FormControlLabel, TextareaAutosize } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import htmlToDraft from 'html-to-draftjs';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import draftToHtml from 'draftjs-to-html';
import AdmissionAddRemarks from '../Admission/components/AdmissionAddRemarks';
import {
  AddIcon,
  ArrowLeftIcon,
  DropDownIcon,
  DropUpIcon,
  FemaleIcon,
  MaleIcon,
  Reset2,
  XmaleIcon,
} from '../../components/Icon';
import Text from '../../components/Text';
import TitleBox from '../Admission/components/TitleBox.js/index.js';
import StatusUI from '../Admission/components/StatusUI/index.js';
import HandingUI from '../Admission/components/HandingUI';
import { Alert } from '../../components';
import StyleInput from '../../components/StyleInput/index.js';
import BusStopUI from '../Admission/components/BusStop/components/BusStopUI';
import AdmissionRadio from '../Admission/components/AdmissionRadio';
import StyleButton from '../../components/StyleButton';
import RichText from '../Admission/components/RichText';
import { eadmissionAPI } from '../../apis';
import admissionUtil from '../../utils/admissionUtil';
import { editorStateInsertText, handleDeleteEmbedBug, isNotEmptyArray } from '../../utils/newBedStatusUtil';
import { conditional, initValue } from '../../utils';
import { i18n } from '../../language';
import { useQuery } from '../../utils/useQuery.js';
import RedirectPopup from '../Admission/components/Popups/RedirectPopup/index.js';
import MdroInfo from '../../components/MdroInfo';
import CancelAssignedPopup from '../Admission/components/Popups/CancelAssignedPopup';
import { Checkbox } from '../DutyAssign/components/Attendance/Setting';
import NotificationPopup from '../Admission/components/Popups/NotificationPopup';
import { useActionableTicketReminder } from '../../utils/hooks';
import { alertMsg } from '../../apis/commlogic.js';
import RefreshButton from '../../components/RefreshButton/index.js';
import { getGenderColor } from '../Admission/components/BusStop/components/index.js';
import AlertConfirm from '../Admission/EmergencyAdmission/EAdmissionForm/Alert.js';

const useStyles = makeStyles((theme) => ({
  backBtn: {
    gap: '0.5rem',
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
  arrowLeftIcon: {
    color: '#538FFF',
    fontSize: '1rem',
  },
  dropBtn: {
    width: '1.5rem',
    height: '1.5rem',
  },
  dropIcon: {
    fontSize: '1.125rem',
    color: '#538FFF',
  },
  femaleIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: '#FF8181',
  },
  maleIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: '#538FFF',
  },
  xmaleIcon: {
    width: '1.5rem',
    height: '1.5rem',
    color: '#7B80FF',
  },
  star: {
    color: '#F00',
  },
  border: {
    height: '1px',
    backgroundColor: '#E4E7EB',
  },
  radioGroup: {
    '& .MuiTypography-root': {
      color: '#7D86A9',
      fontSize: '1rem',
    },
    gap: '3rem',
  },
  Covid19: {
    fontSize: '1.25rem',
    color: '#D81E06',
  },
  resetIcon: {
    fontSize: '1.1rem',
    color: '#538FFF',
    marginRight: '0.5rem',
  },
  admit: {
    backgroundColor: '#F5FAFE',
    borderRadius: '0.25rem',
    padding: '0.25rem 0.375rem',
    fontSize: '1rem',
    color: '#7D86A9',
  },
}));

const BSAdmissionDetail = () => {
  const classes = useStyles();
  const { id } = useParams();
  const history = useHistory();
  const loginInfo = useSelector((state) => state.loginInfo);
  const isInitialRender = useRef(true);
  const { transferRequestId, actionableMode } = useQuery();
  const [detailCtrl, setDetailCtrl] = useState({
    patientInfo: true,
    eAED: true,
    alert: true,
    remark: true,
  });
  const [detail, setDetail] = useState();
  const [defaultValue, setDefaultValue] = useState();
  const [btnCtrl, setBtnCtrl] = useState();
  const [successAlert, setSuccessAlert] = useState(false);
  const [redirectPopup, setRedirectPopup] = useState(false);
  const [cancelAssignWardPopup, setCancelAssignWardPopup] = useState(false);
  const [ulOpen, setUlOpen] = useState(false);
  const location = useLocation();
  const bedStatusMode = location.pathname.includes('bedstatus');
  const [specialAlertList, setSpecialAlertList] = useState([]);
  const [updateRemarkOrSpecialAlert, setUpdateRemarkOrSpecialAlert] = useState(false);
  const [notificationPopup, setNotificationPopup] = useState(false);
  const [refresh, setRefresh] = useState(true);
  useActionableTicketReminder('audio', bedStatusMode ? 'BS' : 'AD');

  const getAdmissionForm = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getAdmissionDetail({ eaId: id });
      let addtlRmkInfo = '';
      if (result.addtlRmkInfo) {
        const blocksFromHtml = htmlToDraft(result.addtlRmkInfo);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        addtlRmkInfo = EditorState.createWithContent(contentState);
      } else {
        addtlRmkInfo = EditorState.createEmpty();
      }
      setDetail({
        ...result,
        addtlRmkInfo,
        patInfo: {
          ...result.patInfo,
          remark: result?.patInfo?.remark ?? '',
          specialAlert: result?.patInfo?.specialAlert ?? '',
        },
      });
    } catch (error) {}
  }, [id]);

  const getBtnDisplay = useCallback(async () => {
    try {
      if (transferRequestId) {
        const { result } = await eadmissionAPI.getTransferInDisplay({ transferRequestId });
        setBtnCtrl(result);
      } else {
        const { result } = await eadmissionAPI.getAdmissionDisplay({ eaId: id, type: bedStatusMode ? 2 : 1 });
        setBtnCtrl(result);
      }
    } catch (error) {}
  }, [id, transferRequestId]);

  useEffect(() => {
    getAdmissionForm();
    getBtnDisplay();
  }, [getAdmissionForm, getBtnDisplay, refresh]);

  const handleDetail = (type) => () => {
    setDetailCtrl((oldDetail) => ({
      ...oldDetail,
      [type]: !oldDetail[type],
    }));
  };

  const updateDetail = (key) => {
    switch (key) {
      case 'priority':
        return () =>
          setDetail((preData = {}) => ({
            ...preData,
            patInfo: {
              ...preData.patInfo,
              priority: preData.patInfo?.priority === 1 ? 0 : 1,
            },
          }));
      case 'remark':
      case 'specialAlert':
        return (value) => {
          setUpdateRemarkOrSpecialAlert(true);
          setDetail((preData = {}) => ({
            ...preData,
            patInfo: {
              ...preData.patInfo,
              [key]: value,
            },
          }));
        };
      case 'specialtyRemark':
        return (value) => {
          setUpdateRemarkOrSpecialAlert(true);
          setDetail((preData = {}) => ({
            ...preData,
            patInfo: {
              ...preData.patInfo,
              [key]: value?.slice(0, 20),
            },
          }));
        };
      case 'addtlRmkInfo':
        return (value) =>
          setDetail((preData = {}) => ({
            ...preData,
            addtlRmkInfo: value,
          }));
      case 'generalConditions':
        return (e) =>
          setDetail((preData = {}) => ({
            ...preData,
            eaedInfo: {
              ...preData.eaedInfo,
              status: e.target.value,
            },
          }));
      default:
        break;
    }
  };

  const getSpecialAlertList = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialAlertList();
      setSpecialAlertList(
        _.map(
          _.filter(result.data, (item) => item.status === 1),
          (item) => ({ remark: item.specialAlert })
        )
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getSpecialAlertList();
  }, [getSpecialAlertList, refresh]);

  const getSpecialtyAdditionalRemark = useCallback(async () => {
    try {
      if (detail?.patInfo?.specialtyCode) {
        const params = {
          specialtyCode: detail?.patInfo?.specialtyCode,
          subSpecialtyCode: detail?.patInfo?.subSpecialtyCode,
          caseNo: detail?.patInfo?.caseNo,
          ipasHospCode: detail?.patInfo?.ipasHospCode,
        };
        const { result } = await eadmissionAPI.getSpecialtyAdditionalRemark(params);
        let additionalRemark = '';
        if (result.additionalRemark) {
          const blocksFromHtml = htmlToDraft(result.additionalRemark);
          const { contentBlocks, entityMap } = blocksFromHtml;
          const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
          additionalRemark = EditorState.createWithContent(contentState);
          setDefaultValue((preData) => ({ ...preData, additionalRemark }));
        }
      }
    } catch (error) {}
  }, [detail?.patInfo?.specialtyCode, detail?.patInfo?.subSpecialtyCode]);

  useEffect(() => {
    getSpecialtyAdditionalRemark();
  }, [getSpecialtyAdditionalRemark, refresh]);

  const getSpecialtyDefaultList = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialtyDefaultList();
      setDefaultValue((preData) => ({ ...result.specialtyDefault, additionalRemark: preData?.additionalRemark ?? '' }));
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getSpecialtyDefaultList();
  }, [getSpecialtyDefaultList, refresh]);

  const resetAdditionalRemarkDefaultValue = () => {
    if (!defaultValue?.additionalRemark) {
      return;
    }

    setDetail((preData = {}) => ({
      ...preData,
      addtlRmkInfo: defaultValue.additionalRemark,
    }));
  };

  const handleAdmissionVersionError = useAdmissionVersionError();
  const editAdmission = useCallback(
    async (actionType, save, callback, otherInfo = {}) => {
      try {
        const params = {
          actionType,
          eaId: id,
          patInfo: {
            additionalRemark: handleDeleteEmbedBug(detail?.addtlRmkInfo),
            priority: detail?.patInfo?.priority,
            remark: detail?.patInfo?.remark,
            specialAlert: detail?.patInfo?.specialAlert,
            specialtyRemark: detail?.patInfo?.specialtyRemark,
          },
          version: detail?.patInfo?.version,
          unitType: btnCtrl?.UNIT_TYPE || '',
          transferRequestId,
          ...otherInfo,
        };
        await eadmissionAPI.editAdmission(params);
        getBtnDisplay();
        getAdmissionForm();
        setSuccessAlert(Boolean(save));
        callback && callback();
      } catch (error) {
        handleAdmissionVersionError(error);
      }
    },
    [btnCtrl, detail, id, getBtnDisplay, getAdmissionForm, transferRequestId]
  );

  const handleRouteToWardAssignmentPage = () => {
    history.push({
      pathname: `/admissionWardAssignment`,
      search: new URLSearchParams({
        id: detail?.patInfo?.busStopInfo?.BUS_STOP_ID,
        eaId: id,
        gender: detail?.patInfo?.sex,
        specialtyCode: detail?.patInfo?.specialtyCode === 'null' ? null : detail?.patInfo?.specialtyCode,
        subSpecialtyCode: detail?.patInfo?.subSpecialtyCode === 'null' ? null : detail?.patInfo?.subSpecialtyCode,
        actionableMode: actionableMode === '1' ? '1' : null,
        isolationRoomCode: detail?.eaedInfo?.isolationRoomCode,
      }).toString(),
    });
  };

  const handleBtnEvents = (type) => () => {
    switch (type) {
      case 'Withdraw':
      case 'Hold':
      case 'Cancel holding':
      case 'Confirm Adm. Ready':
      case 'Acknowledge':
      case 'Ward Ready':
      case 'ACK. and ward ready':
        editAdmission(admissionUtil.actionTypeEnum[type]);
        break;
      case 'Cancel Assignd Ward & Re-assign':
        setCancelAssignWardPopup(true);
        break;
      case 'Save':
        const callback = () => {
          setUpdateRemarkOrSpecialAlert(false);
          if (detail?.patInfo?.status !== 'Pending' && updateRemarkOrSpecialAlert) {
            setNotificationPopup(true);
          }
        };
        editAdmission(admissionUtil.actionTypeEnum[type], true, callback, {});
        break;
      case 'Assign Ward':
        handleRouteToWardAssignmentPage();
        break;
      case 'Cancel':
        history.goBack();
        break;
      case 'Redirect':
        setRedirectPopup(true);
        break;

      default:
        break;
    }
  };

  const handleRedirect = async (otherParams) => {
    try {
      await editAdmission(10, false, () => {}, otherParams);
      setRedirectPopup(false);
    } catch (error) {}
  };

  const [remarkPopAchorEl, setRemarkAnchorEl] = useState(null);

  const [isFlag, setIsFlag] = useState(null); // 判断上下按钮

  const [remarkList, setRemarkList] = useState();
  const getAddRemarkList = async () => {
    try {
      const { result } = await eadmissionAPI.getRemarkList({
        // pageNO: 1,
        // pageSize: 20,
        status: 1,
      });
      setRemarkList(result.data);
    } catch {}
  };
  useEffect(() => {
    getAddRemarkList();
  }, [refresh]);

  const [specialtyRemarkList, setSpecialtyRemarkList] = useState([[]]);
  const getSpecialtyRemarkList = async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialtyRemarkList({
        // pageNO: 1,
        // pageSize: 20,
        status: 1,
      });
      setSpecialtyRemarkList(
        _.map(
          _.filter(result.data, (item) => item.status === 1),
          (item) => ({
            remark: item.specialtyRemark,
            remarkId: item.specialtyRemarkId,
          })
        )
      );
    } catch {}
  };
  useEffect(() => {
    getSpecialtyRemarkList();
  }, [refresh]);

  const addRemarkList = useMemo(() => {
    switch (isFlag) {
      case 'specialAlert':
        return specialAlertList;
      case 'remark':
      case 'addtlRmkInfo':
        return remarkList;
      case 'specialtyRemark':
        return specialtyRemarkList;
      default:
        break;
    }
  }, [isFlag, specialAlertList, remarkList, specialtyRemarkList]);

  // remark popup 开关
  const handleRemarkPopup = useCallback(
    (id, event) => {
      setRemarkAnchorEl(remarkPopAchorEl ? null : event.currentTarget);
      setIsFlag(id);
    },
    [remarkPopAchorEl]
  );
  // remark popup 关闭
  const handleCloseRemarkPopup = () => {
    setRemarkAnchorEl(null);
  };
  // remark popup 选择
  const handleSelectRemark = (remark) => {
    switch (isFlag) {
      case 'remark':
        setUpdateRemarkOrSpecialAlert(true);
        setDetail((o = {}) => ({
          ...o,
          patInfo: {
            ...o.patInfo,
            remark: `${o.patInfo?.remark || ''} ${remark}`.slice(0, 99),
          },
        }));
        setRemarkAnchorEl(null);
        break;
      case 'addtlRmkInfo':
        setDetail((o = {}) => ({
          ...o,
          addtlRmkInfo: editorStateInsertText(o.addtlRmkInfo, remark),
        }));
        setRemarkAnchorEl(null);
        break;
      case 'specialAlert':
        setUpdateRemarkOrSpecialAlert(true);
        setDetail((o = {}) => ({
          ...o,
          patInfo: {
            ...o.patInfo,
            specialAlert: `${o.patInfo?.specialAlert || ''} ${remark}`.slice(0, 99),
          },
        }));
        setRemarkAnchorEl(null);
        break;
      case 'specialtyRemark':
        setUpdateRemarkOrSpecialAlert(true);
        setDetail((o = {}) => ({
          ...o,
          patInfo: {
            ...o.patInfo,
            specialtyRemark: `${o.patInfo?.specialtyRemark || ''} ${remark}`.slice(0, 20),
          },
        }));
        setRemarkAnchorEl(null);
        break;
      default:
        break;
    }
  };

  // 换行
  const initValues = (text) => {
    const lines = text.split('\n');
    const liness = lines.map((line, index) => (
      <div key={line}>
        {line}
        {index < lines.length - 1 ? <br /> : null}
      </div>
    ));
    return liness;
  };
  const isHold = useMemo(() => detail?.patInfo?.status === 'Hold', [detail?.patInfo?.status]);
  const name = admissionUtil.useGetName({ chiName: detail?.patInfo?.chiName, engName: detail?.patInfo?.engName });
  const hkid = admissionUtil.useGetHkid(detail?.patInfo?.hkid);

  useEffect(() => {
    if (bedStatusMode && hkid?.startsWith('UL')) {
      setUlOpen(true);
    }
  }, [hkid]);

  // 当用户切换了或者或者role等，要刷新一下页面重新call api, 第一次进入页面的时候不触发
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    setRefresh((o) => !o);
  }, [loginInfo]);

  if (!detail) {
    return <div />;
  }

  const btnArray = btnCtrl?.BTNS;

  return (
    <>
      <Box>
        {/* header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p="0 2.63rem"
          height="4.375rem"
          bgcolor="#FFF"
          boxShadow="0px 1px 0px 0px #E4E7EB"
        >
          <Box display="flex" gridGap="1rem">
            <ButtonBase className={classes.backBtn} onClick={() => history.goBack()}>
              <ArrowLeftIcon className={classes.arrowLeftIcon} /> Back
            </ButtonBase>
            <RefreshButton handleRefresh={() => setRefresh((o) => !o)} />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            // boxShadow="0px -1px 1px 0px #E4E7EB"
            // p="1.25rem 1.25rem 1.75rem"
            gridGap="1.25rem"
            // position="sticky"
            // bottom={0}
            // zIndex={999}
            bgcolor="#FFFFFF"
          >
            {/* {btnArray?.map((item) => (
              <StyleButton
                key={item}
                {...admissionUtil.eAdmissionFormBtnEnum[item]}
                p="0.88rem 3.25rem"
                width="auto"
                onClick={handleBtnEvents(item)}
              />
            ))} */}
          </Box>
          <div />
        </Box>

        {/* Body */}
        <Box p="1.88rem 3.44rem 0">
          <Box
            display="flex"
            flexDirection="column"
            height={`calc(100vh - ${actionableMode === '1' ? 6.5 : 11.5}rem)`}
            overflow="hidden auto"
            bgcolor="#FFF"
            borderRadius="15px"
            pb="1.75rem"
          >
            <Box display="flex" flexDirection="column" gridGap="1.87rem" p="1.25rem 1.88rem 2.56rem">
              {/*  Patient Info */}
              <Box>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Text color="#2E4469" fontSize="1.25rem" fontFamily="NotoSans-Bold">
                    Patient Info
                  </Text>
                  <ButtonBase className={classes.dropBtn} onClick={handleDetail('patientInfo')}>
                    {detailCtrl.patientInfo ? (
                      <DropUpIcon className={classes.dropIcon} />
                    ) : (
                      <DropDownIcon className={classes.dropIcon} />
                    )}
                  </ButtonBase>
                </Box>
                {detailCtrl.patientInfo && (
                  <>
                    <Box
                      display="grid"
                      gridTemplateColumns="1fr 1fr 1fr 1fr 1fr 1fr"
                      gridGap="2.5rem"
                      mt="1.25rem"
                      mb="4rem"
                    >
                      <TitleBox title="AE# / HKID/Doc.# / HN#">
                        <Text
                          color={getGenderColor(detail?.patInfo?.sex)}
                          fontSize="1.25rem"
                          fontFamily="NotoSans-Bold"
                        >
                          {detail?.patInfo?.caseNo}
                        </Text>
                        <Text
                          color={getGenderColor(detail?.patInfo?.sex)}
                          fontSize="1.25rem"
                          fontFamily="NotoSans-Bold"
                        >
                          {hkid}
                        </Text>
                        <Text
                          color={getGenderColor(detail?.patInfo?.sex)}
                          fontSize="1.25rem"
                          fontFamily="NotoSans-Bold"
                        >
                          {detail?.patInfo?.hnNo}
                        </Text>
                      </TitleBox>
                      <TitleBox title="Patient ">
                        <Box display="flex">
                          {detail?.patInfo?.sex === 'F' && <FemaleIcon className={classes.femaleIcon} />}
                          {detail?.patInfo?.sex === 'M' && <MaleIcon className={classes.maleIcon} />}
                          {detail?.patInfo?.sex === 'X' && <XmaleIcon className={classes.xmaleIcon} />}
                          <Text fontSize="1.25rem" fontFamily="HA_MingLiu, NotoSans-Medium">
                            {name}
                            {detail?.patInfo?.dob
                              ? `, ${moment().diff(moment(detail?.patInfo?.dob, 'DD-MM-YYYY'), 'years')}`
                              : ''}
                          </Text>
                        </Box>
                      </TitleBox>
                      <TitleBox title="Specialty">
                        <Text fontSize="1.25rem">{`${initValue(detail.patInfo.specialtyCode, '')} ${initValue(
                          detail.patInfo.subSpecialtyCode,
                          ''
                        )}`}</Text>
                        <Box display="flex" mb="0.38rem" gridGap="0.62rem" mt="0.38rem">
                          <div className={classes.admit}>{initValue(detail.eaedInfo.admitWard, '')}</div>
                          <div className={classes.admit}>{initValue(detail.eaedInfo.admitSpecialtyOthers, '')}</div>
                        </Box>
                        {/* <Box display="flex" justifyContent="flex-end" mb="0.38rem">
                          <ButtonBase onClick={(event) => handleRemarkPopup('specialtyRemark', event)}>
                            <AddIcon className={classes.resetIcon} />
                            <Text color="#538FFF" fontSize="1rem">
                              Add Specialty Remark
                            </Text>
                          </ButtonBase>
                        </Box> */}
                        <StyleInput
                          value={detail?.patInfo?.specialtyRemark || ' '}
                          onChange={updateDetail('specialtyRemark')}
                          fontSize="1.25rem"
                          // placeholder="Add specialty remark here"
                          disabled={true}
                        />
                      </TitleBox>
                      <TitleBox title="Triage Category">
                        <Text fontSize="1.25rem">{detail?.patInfo?.triageCategory}</Text>
                      </TitleBox>
                      <TitleBox title="Current Status">
                        <StatusUI
                          status={detail?.patInfo?.status}
                          name={detail?.patInfo?.busStopStep}
                          showRedirectIcon={detail?.patInfo?.performRedirect}
                        />
                      </TitleBox>
                      <TitleBox title="Waiting For">
                        <HandingUI
                          handlingByHospCode={detail?.patInfo.handlingByHospCode}
                          handlingByWardName={detail?.patInfo.handlingByWardName}
                          time={detail?.patInfo.handlingBySuffix}
                          NEXT_BUS_STOP_STEP={detail?.patInfo?.busStopInfo?.NEXT_BUS_STOP_STEP}
                          hold={detail?.patInfo?.status === 'Hold'}
                          WARD_ASSIGN_TITLE={detail?.patInfo?.busStopInfo?.WARD_ASSIGN_TITLE}
                        />
                      </TitleBox>
                      <TitleBox title="Adm. Decision Time">
                        <Text fontSize="1.25rem">{moment(detail?.patInfo?.adt).format('YYYY-MM-DD HH:mm')}</Text>
                      </TitleBox>
                      <TitleBox title="Diagnosis (CMS)" style={{ gridColumnStart: 'span 3' }}>
                        <Text fontSize="1.25rem">{detail?.patInfo?.diagnosis}</Text>
                      </TitleBox>
                      <Box display="flex" flexDirection="column" gridGap="1rem" style={{ gridColumnStart: 'span 2' }}>
                        <Text color="#2E4469" fontSize="1rem">
                          Priority
                        </Text>
                        <Checkbox check={detail?.patInfo?.priority === 1} />
                      </Box>
                      {/* TODO: 临时位置，等design出来再调 */}
                      {/* <Box display="flex" flexDirection="column" gridGap="1rem" style={{ gridColumnStart: 'span 2' }}>
                        <Box display="flex" justifyContent="space-between">
                          <Text color="#2E4469" fontSize="1rem">
                            Specialty Remark
                          </Text>
                          <ButtonBase onClick={(event) => handleRemarkPopup('specialtyRemark', event)}>
                            <AddIcon className={classes.resetIcon} />
                            <Text color="#538FFF" fontSize="1rem">
                              Add Specialty Remark
                            </Text>
                          </ButtonBase>
                        </Box>
                        <StyleInput
                          value={detail?.patInfo?.specialtyRemark}
                          onChange={updateDetail('specialtyRemark')}
                          fontSize="1.25rem"
                          placeholder="Add specialty remark here"
                        />
                      </Box> */}
                      <TitleBox title="MDRO">
                        <Box display="flex" flexWrap="wrap" gridGap="0.62rem">
                          {isNotEmptyArray(detail?.alertInfo?.mdroInfos)
                            ? detail?.alertInfo?.mdroInfos.map((item) => (
                                <MdroInfo content={item.alertDesc} key={item.alertDesc} popValue={item} />
                              ))
                            : '--'}
                        </Box>
                      </TitleBox>
                      <TitleBox title="COVID">
                        {detail?.alertInfo?.covidInfo ? (
                          <Box
                            color="#B92B21"
                            fontSize="1rem"
                            wordWrap="break-word"
                            bgcolor="#FAE5E5"
                            borderRadius="5px"
                            padding="1rem"
                          >
                            {`${detail?.alertInfo?.covidInfo?.lab}:${detail?.alertInfo?.covidInfo?.value}`}
                          </Box>
                        ) : (
                          '--'
                        )}
                      </TitleBox>
                      <TitleBox title="CXR" style={{ gridColumnStart: 'span 2' }}>
                        {detail.eaedInfo.cxrInfos?.length > 0
                          ? detail.eaedInfo.cxrInfos.map((item) => (
                              <Text fontSize="1.25rem" key={`${item?.gcrName}:${item?.gcrContent}`}>
                                {`${item?.gcrName}:${item?.gcrContent}`}
                              </Text>
                            ))
                          : '--'}
                      </TitleBox>
                      <TitleBox title="TOCC">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.tocc, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="Oxygen req.">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.oxygenReq, '--')}</Text>
                      </TitleBox>
                      {/* <Box display="flex" flexDirection="column" gridGap="1rem">
                        <Text color="#2E4469" fontSize="1rem">
                          AE O-ward Bed No.
                        </Text>
                        <Text fontSize="1.25rem">{detail?.patInfo?.owBedNo}</Text>
                      </Box> */}
                      <Box display="flex" flexDirection="column" gridGap="1rem" style={{ gridColumnStart: 'span 2' }}>
                        <Box display="flex" justifyContent="space-between">
                          <Text color="#2E4469" fontSize="1rem">
                            Special Alert
                          </Text>
                          {/* <ButtonBase onClick={(event) => handleRemarkPopup('specialAlert', event)}>
                            <AddIcon className={classes.resetIcon} />
                            <Text color="#538FFF" fontSize="1rem">
                              Add Special Alert
                            </Text>
                          </ButtonBase> */}
                        </Box>
                        <StyleInput
                          value={detail?.patInfo?.specialAlert || ' '}
                          onChange={updateDetail('specialAlert')}
                          fontSize="1.25rem"
                          // placeholder="Add special alert here"
                          disabled={true}
                        />
                      </Box>
                      <Box display="flex" flexDirection="column" gridGap="1rem" style={{ gridColumnStart: 'span 2' }}>
                        <Box display="flex" justifyContent="space-between">
                          <Text color="#2E4469" fontSize="1rem">
                            Remark
                          </Text>
                          {/* <ButtonBase onClick={(event) => handleRemarkPopup('remark', event)}>
                            <AddIcon className={classes.resetIcon} />
                            <Text color="#538FFF" fontSize="1rem">
                              Add Remark
                            </Text>
                          </ButtonBase> */}
                        </Box>
                        <StyleInput
                          value={detail?.patInfo?.remark || ' '}
                          onChange={updateDetail('remark')}
                          fontSize="1.25rem"
                          disabled={true}
                          // placeholder="Add remark here"
                        />
                      </Box>
                      <Box display="flex" flexDirection="column" gridGap="1rem" style={{ gridColumnStart: 'span 2' }}>
                        <TitleBox title="Discharged Remark">
                          <Text fontSize="1.25rem">
                            {initValues(initValue(detail?.eaedInfo?.dischargeRemark, '--'))}
                          </Text>
                        </TitleBox>
                      </Box>
                    </Box>

                    <BusStopUI
                      editView={true}
                      data={detail?.patInfo?.busStopInfo}
                      busStopStep={detail?.patInfo?.busStopStep}
                      hold={isHold}
                      gender={detail?.patInfo?.sex}
                    />
                  </>
                )}
              </Box>
              <div className={classes.border} />
              {/* eAED Info */}
              <Box>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Text color="#2E4469" fontSize="1.25rem" fontFamily="NotoSans-Bold">
                    eAED Info
                  </Text>
                  <ButtonBase className={classes.dropBtn} onClick={handleDetail('eAED')}>
                    {detailCtrl.eAED ? (
                      <DropUpIcon className={classes.dropIcon} />
                    ) : (
                      <DropDownIcon className={classes.dropIcon} />
                    )}
                  </ButtonBase>
                </Box>
                {detailCtrl.eAED && (
                  <Box display="flex" flexDirection="column" gridGap="1.25rem" mt="1.3rem">
                    <Text color="#538FFF" fontFamily="NotoSans-Bold" textTransform="uppercase">
                      General Conditions
                    </Text>
                    <RadioGroup
                      className={classes.radioGroup}
                      row
                      aria-label="position"
                      name="position"
                      value={detail?.eaedInfo?.status}
                      // onChange={updateDetail('generalConditions')}
                    >
                      <FormControlLabel
                        disabled={true}
                        value="Satisfactory"
                        label="Satisfactory"
                        control={<AdmissionRadio />}
                      />
                      <FormControlLabel disabled={true} value="Stable" label="Stable" control={<AdmissionRadio />} />
                      <FormControlLabel disabled={true} value="Serious" label="Serious" control={<AdmissionRadio />} />
                      <FormControlLabel
                        disabled={true}
                        value="Critical"
                        label="Critical"
                        control={<AdmissionRadio />}
                      />
                      <FormControlLabel disabled={true} value="Dead" label="Dead" control={<AdmissionRadio />} />
                    </RadioGroup>
                    <Box display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gridGap="1.88rem">
                      <TitleBox title="Temp">
                        <Text fontSize="1.25rem">
                          {conditional(detail?.eaedInfo?.temp, `${detail?.eaedInfo?.temp}`, '--')}
                        </Text>
                      </TitleBox>
                      <TitleBox title="SpO2">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.spo2, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="Oxygen req.">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.oxygenReq, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="Blood pressure">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.bloodPressure, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="Pulse rate">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.pulseRate, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="GCS">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.gcs, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="Pregnant">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.pregnant, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="LMP">
                        <Text fontSize="1.25rem">
                          {conditional(detail?.eaedInfo?.lmp, moment(detail?.eaedInfo?.lmp).format('YYYY-MM-DD'), '--')}
                        </Text>
                      </TitleBox>
                      <TitleBox title="Conscious level">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.consciousLevel, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="TOCC">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.tocc, '--')}</Text>
                      </TitleBox>
                      <TitleBox title="Amb status">
                        <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.ambStatus, '--')}</Text>
                      </TitleBox>
                    </Box>
                    <Box display="flex" flexDirection="column" gridGap="1.25rem">
                      <Text color="#538FFF" fontFamily="NotoSans-Bold" textTransform="uppercase">
                        other medical information
                      </Text>
                      <TitleBox title="Present symptoms">
                        <Text fontSize="1.25rem">{initValues(initValue(detail?.eaedInfo?.presentSym, '--'))}</Text>
                      </TitleBox>
                      <Box display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gridGap="1.88rem">
                        <TitleBox title="Condition on arrivals">
                          <Text fontSize="1.25rem">
                            {initValues(initValue(detail?.eaedInfo?.conditionOnArrivals, '--'))}
                          </Text>
                        </TitleBox>
                        <TitleBox title="Chief complaint">
                          <Text fontSize="1.25rem">
                            {initValues(initValue(detail?.eaedInfo?.chiefComplaint, '--'))}
                          </Text>
                        </TitleBox>
                        <TitleBox title="Past health">
                          <Text fontSize="1.25rem">{initValues(initValue(detail?.eaedInfo?.pastHealth, '--'))}</Text>
                        </TitleBox>
                        <TitleBox title="Triage remarks">
                          <Text fontSize="1.25rem">{initValues(initValue(detail?.eaedInfo?.triageRmks, '--'))}</Text>
                        </TitleBox>
                      </Box>
                    </Box>
                    <Box display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gridGap="0.56rem 1.88rem">
                      <Box style={{ gridColumnStart: 1, gridColumnEnd: 5 }}>
                        <Text color="#538FFF" fontFamily="NotoSans-Bold" textTransform="uppercase">
                          Discharge
                        </Text>
                      </Box>
                      <Box
                        p={conditional(detail?.eaedInfo?.isolationRoom, '0.62rem', '0.62rem 0 0')}
                        borderRadius="4px"
                        bgcolor={conditional(detail?.eaedInfo?.isolationRoom, '#FFF2C1', '#FFF')}
                      >
                        <TitleBox title="Isolation room" titleColor="#333">
                          <Text
                            fontSize="1.25rem"
                            color={conditional(detail?.eaedInfo?.isolationRoom, '#538FFF', '#7D86A9')}
                          >
                            {initValue(detail?.eaedInfo?.isolationRoom, '--')}
                          </Text>
                        </TitleBox>
                      </Box>
                      <Box pt="0.62rem">
                        <TitleBox title="Discharge destination">
                          <Text fontSize="1.25rem">{initValue(detail?.eaedInfo?.dischargeDestination, '--')}</Text>
                        </TitleBox>
                      </Box>
                      <Box pt="0.62rem">
                        <TitleBox title="Discharge time">
                          <Text fontSize="1.25rem">
                            {conditional(
                              detail?.eaedInfo?.dischargeTime,
                              moment(detail?.eaedInfo?.dischargeTime).format('YYYY-MM-DD HH:mm'),
                              '--'
                            )}
                          </Text>
                        </TitleBox>
                      </Box>
                      <Box pt="0.62rem">
                        <TitleBox title="Discharge remark">
                          <Text fontSize="1.25rem">
                            {initValues(initValue(detail?.eaedInfo?.dischargeRemark, '--'))}
                          </Text>
                        </TitleBox>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
              {/* <div className={classes.border} /> */}
              {/* Alert */}
              <div className={classes.border} />
              {/* Additional Remark */}
              <Box>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Text color="#2E4469" fontSize="1.25rem" fontFamily="NotoSans-Bold">
                    Additional Remark
                  </Text>
                  <ButtonBase className={classes.dropBtn} onClick={handleDetail('remark')}>
                    {detailCtrl.remark ? (
                      <DropUpIcon className={classes.dropIcon} />
                    ) : (
                      <DropDownIcon className={classes.dropIcon} />
                    )}
                  </ButtonBase>
                </Box>
                {detailCtrl.remark && (
                  <>
                    {/* <Box display="flex" justifyContent="end" m="1.25rem 0" gridGap="1.87rem">
                      <ButtonBase onClick={resetAdditionalRemarkDefaultValue}>
                        <Reset2 className={classes.resetIcon} />
                        <Text color="#538FFF" fontSize="1rem">
                          Reset to default value
                        </Text>
                      </ButtonBase>
                      <ButtonBase onClick={(event) => handleRemarkPopup('addtlRmkInfo', event)}>
                        <AddIcon className={classes.resetIcon} />
                        <Text color="#538FFF" fontSize="1rem">
                          Add Remark
                        </Text>
                      </ButtonBase>
                    </Box> */}
                    <Box mt="1rem">
                      <RichText
                        disabled={true}
                        value={detail?.addtlRmkInfo}
                        onChange={updateDetail('addtlRmkInfo')}
                        fontSize="1.25rem"
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Box>
            {/* Footer */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              // boxShadow="0px -1px 1px 0px #E4E7EB"
              // p="1.25rem 1.25rem 1.75rem"
              gridGap="1.25rem"
              // position="sticky"
              // bottom={0}
              // zIndex={999}
              bgcolor="#FFFFFF"
            >
              {/* {btnCtrl?.BTNS?.map((item) => (
                <StyleButton
                  key={item}
                  {...admissionUtil.eAdmissionFormBtnEnum[item]}
                  p="0.88rem 3.25rem"
                  width="auto"
                  onClick={handleBtnEvents(item)}
                />
              ))} */}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* alert */}
      <Alert
        open={successAlert}
        id="DutyAssign-Alert-aib"
        onClose={() => setSuccessAlert(false)}
        text={i18n.t('DUTYASSIGN_SAVE_SUCCESS_ALERT')}
        type="success"
      />
      {/* addRemarks */}
      <AdmissionAddRemarks
        anchorEl={remarkPopAchorEl}
        handleClose={handleCloseRemarkPopup}
        handleClick={handleSelectRemark}
        remarkList={addRemarkList}
      />

      {/* Popups */}
      {redirectPopup && (
        <RedirectPopup handleRedirect={handleRedirect} eaId={id} handleClose={() => setRedirectPopup(false)} />
      )}
      {cancelAssignWardPopup && (
        <CancelAssignedPopup
          handleClose={() => setCancelAssignWardPopup(false)}
          handleConfirm={() => {
            editAdmission(7, false, handleRouteToWardAssignmentPage, {});
          }}
        />
      )}
      {ulOpen && <AlertConfirm onClose={() => setUlOpen(false)} />}
      {notificationPopup && (
        <NotificationPopup
          eaId={detail.patInfo.eaId}
          caseNo={detail?.patInfo?.caseNo}
          ipasHospCode={detail.patInfo.ipasHospCode}
          specialtyCode={detail?.patInfo?.specialtyCode}
          subSpecialtyCode={detail?.patInfo?.subSpecialtyCode}
          handleClose={() => setNotificationPopup(false)}
        />
      )}
    </>
  );
};

export const useAdmissionVersionError = () => {
  useEffect(() => {
    const reloadCallbackMsg = sessionStorage.getItem('reloadCallbackMsg');
    if (typeof reloadCallbackMsg === 'string') {
      const timeout = setTimeout(() => {
        alertMsg(reloadCallbackMsg);
        sessionStorage.removeItem('reloadCallbackMsg');
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, []);
  return (error) => {
    if (error.statusCode === '3320') {
      window.location.reload();
      sessionStorage.setItem('reloadCallbackMsg', error.statusMessage);
    }
  };
};

export default BSAdmissionDetail;
